import React from "react";
import Button from "../../../../Components/FormElements/Button";
import InputNumber from "../../../../Components/inputNumber";
import ErrorCustom from "../../../../Components/errorCustom";
import { FieldValues, NestDataObject, OnSubmit } from "react-hook-form";
import FirstCardImproveModality from "./ImproveModalityCardChildren/firstCard";
import SecondCardImproveModality from "./ImproveModalityCardChildren/secondCard";
import ThirdCardImproveModality from "./ImproveModalityCardChildren/thirdCard";

interface ImproveModalityCardProps {
  data: any;
  selectedModality: any;
  typeMoneyDescriptionList: any;
  handleSubmit: (
    callback: OnSubmit<FieldValues>
  ) => (e?: React.BaseSyntheticEvent) => Promise<void>;
  onSubmitImprovement: (values: any) => Promise<void>;
  setValue: any;
  register: any;
  errors: NestDataObject<FieldValues>;
  improvedData: any;
  saveImprovement: () => Promise<void>;
}

const ImproveModalityCard = ({
  data,
  selectedModality,
  typeMoneyDescriptionList,
  handleSubmit,
  onSubmitImprovement,
  setValue,
  register,
  errors,
  improvedData,
  saveImprovement,
}: ImproveModalityCardProps) => {
  const quote = selectedModality && selectedModality.respuestaMacro && (selectedModality.respuestaMacro.cotiza === "Cotiza");
  return (
    <>
      {/* primera card valor inicial */}
      { selectedModality.respuestaMacroInicial && ( <FirstCardImproveModality data={data} selectedModality={selectedModality} typeMoneyDescriptionList={typeMoneyDescriptionList} isInitialModality={true}/> )}
      {/* segunda card valor incial*/}
      { selectedModality.respuestaMacroInicial && ( <SecondCardImproveModality selectedModality={selectedModality} isInitialModality={true}/> )}
      {/* primera card */}
      <FirstCardImproveModality data={data} selectedModality={selectedModality} typeMoneyDescriptionList={typeMoneyDescriptionList} isInitialModality={false}/>
      {/* segunda card */}
      <SecondCardImproveModality selectedModality={selectedModality} isInitialModality={false}/>
      {/* form */}
      <form onSubmit={handleSubmit(onSubmitImprovement)} className="clientForm">
        <div className="vasForm__form__input-container-select">
          <label>Tasa de Venta</label>
          <InputNumber
            key={`tir-${selectedModality && selectedModality.id}-${selectedModality && selectedModality.indice}`}
            nameVal="tir"
            setValue={setValue}
            register={register}
            thousandSeparator={","}
            suffix={"%"}
            allowNegative={true}
            validatorInput={(value: any) => console.log("")}
            init={0}
          />
          <ErrorCustom errors={errors} name="tir" />
        </div>

        <div className="vasForm__form__input-container-select">
          <label>% Cesión de comisión (0-100)</label>
          <InputNumber
            key={`cesionComision-${selectedModality && selectedModality.id}-${selectedModality && selectedModality.indice}`}
            nameVal="cesionComision"
            setValue={setValue}
            register={register}
            suffix={"%"}
            validatorInput={(value: any) => console.log("cesion_comision")}
            init={0}
          />
          <ErrorCustom errors={errors} name="cesionComision" />
        </div>

        <div className="actions">
          <Button type="submit" className="btn is-secondary actions__cancel">
            Cotizar
          </Button>
        </div>
      </form>
      {/* tercera card */}
      {improvedData && (
        <ThirdCardImproveModality improvedData={improvedData} quote={quote}/>
      )}
      {/* seccion buttons */}
      <div className="actions">
        <Button
          disabled={!improvedData}
          onClick={() => saveImprovement()}
          className="actions__continue"
        >
          Guardar
        </Button>
      </div>
    </>
  );
};

export default ImproveModalityCard;
